import { createSlice } from "@reduxjs/toolkit";

const dataEmptyState = {
  data: {},
};

export const dataSlice = createSlice({
  name: "data",
  initialState: dataEmptyState,
  reducers: {
    responseFetchData: (state, action) => action.payload,

    resetFetchData: () => dataEmptyState,
  },
});

// Action creators are generated for each case reducer function
export const { responseFetchData, resetFetchData } = dataSlice.actions;

export default dataSlice.reducer;
